var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/lollipop')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/dumbbell')(Highcharts);
Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});

export class FinancialForecastLineChart {



    public initializeChart(id: string, yAxisLabel: string, series: any[]): any {
        let chart: any = Highcharts.chart(id, {
            chart: {
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'center', // right by default
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0
                    },
                    relativeTo: 'chart'
                }
            },
            tooltip: {
                //xDateFormat: '%m/%d/%Y',
                xDateFormat: '%d%b%Y',
                shared: true,
                split: false,
                enabled: true,
                valuePrefix: '$',
                formatter: function (tooltip) {
                    //to make points appear in order in tooltip
                    this.points.reverse();
                    return tooltip.defaultFormatter.call(this, tooltip);
                },
            },
            title: {
                text: ''
            },
            credits: { enabled: false },
            plotOptions: {
                line: {
                    marker: { enabled: false }
                }
            },
            yAxis: {
                title: { text: yAxisLabel },
                labels: {
                    formatter: function () {
                        if (this.value >= 1000000) {
                            let millionsVal = (this.value / 1000000);
                            let styledVal = Highcharts.numberFormat(millionsVal, 0, '.', ',');
                            return "$" + styledVal + 'M'
                        }
                        else if (this.value >= 100000) {
                            let millionsVal = (this.value / 1000);
                            let styledVal = Highcharts.numberFormat(millionsVal, 0, '.', ',');
                            return "$" + styledVal + 'K'
                        }
                        else {
                            let styledVal = Highcharts.numberFormat(this.value, 0, '.', ',');
                            return "$" + styledVal
                        }
                    }
                }
            },
            xAxis: {
                type: 'datetime',
                crosshair: {
                    snap: true
                },
                labels: {
                    formatter: function () {
                        let date = new Date(this.value);
                        date.setDate(date.getDate() - 1);
                        return Highcharts.dateFormat('%d%b%y', date.getTime());
                    }
                },
                events: {
                    afterSetExtremes: function (event) {
                        let resetZoomId = "#" + id + "-resetZoom";
                        if (event.max < event.dataMax || event.min > event.dataMin) {
                            $(resetZoomId).show();

                        }
                        else {
                            $(resetZoomId).hide();
                        }
                    }
                }
            },
            legend: {
                enabled: true,
                reversed: true,
                margin: 10,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                symbolHeight: 8,
                symbolWidth: 8,
                symbolRadius: 4,
                symbolPadding: 7
            },
            series: series
        });

        return chart;
    }

    public createChartSeries(isTrendGraph: boolean = false): any[] {
        let series: any[] = [];
        if (isTrendGraph) {
            series.push({ id: 'Expected', name: 'Forecast Spend (Enrollment Trends)', data: [], color: '#E59F00', dashStyle: 'dot', type: 'lollipop', connectorWidth: 1, marker: { radius: 3, symbol: 'circle' } });
        }
        else {
            series.push({ id: 'Expected', name: 'Forecast Spend (Enrollment Projections)', data: [], color: '#CA6876', dashStyle: 'dot', type: 'lollipop', connectorWidth: 1, marker: { radius: 3, symbol: 'circle' } });
        }
        series.push({ id: 'CumulativeInvoiced', name: 'Invoiced', data: [], color: "#8ACCEE", dashStyle: 'solid', step: 'left', type: 'area', marker: { lineWidth: '0', lineColor: "#8ACCEE" } });
        series.push({ id: 'CumulativeEstimated', name: 'Estimated Spend', data: [], color: "#4AA79A", dashStyle: 'solid', step: 'left', type: 'area', marker: { lineWidth: '0', lineColor: "#4AA79A" } });
        series.push({ id: 'Budget', name: 'Budget', data: [], color: "#504392", dashStyle: 'solid', step: 'left', type: 'line', marker: { lineWidth: '0', lineColor: "#504392" } });

        return series;
    }
}